import { c as _c } from "react/compiler-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { type ComponentType, FC, type JSX, type ReactNode, Suspense } from 'react';
import ErrorBoundary from '../ErrorBoundary';
import type { ErrorComponent } from '@/types';
type Component<P extends {}> = ((props: P) => Promise<JSX.Element | null>) | ((props: P) => ReactNode) | ComponentType<P>;
function WithSuspense<PropsType extends {}>(component: Component<PropsType>, loadingComponent?: () => JSX.Element | null, errorComponent?: ErrorComponent) {
  const DataLoadingComponent = component;
  const Loading = loadingComponent;
  const displayName = (DataLoadingComponent as any).displayName ?? `WithSuspense`;
  if (Loading && errorComponent) {
    const WrappedComponent: FC<PropsType> = function (props) {
      const $ = _c(3);
      let t0;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = <Loading />;
        $[0] = t0;
      } else {
        t0 = $[0];
      }
      let t1;
      if ($[1] !== props) {
        t1 = <ErrorBoundary errorComponent={errorComponent}><Suspense fallback={t0}><DataLoadingComponent {...props} /></Suspense></ErrorBoundary>;
        $[1] = props;
        $[2] = t1;
      } else {
        t1 = $[2];
      }
      return t1;
    };
    WrappedComponent.displayName = displayName;
    return WrappedComponent;
  }
  if (Loading) {
    const WrappedComponent: FC<PropsType> = function (props) {
      const $ = _c(3);
      let t0;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = <Loading />;
        $[0] = t0;
      } else {
        t0 = $[0];
      }
      let t1;
      if ($[1] !== props) {
        t1 = <Suspense fallback={t0}><DataLoadingComponent {...props} /></Suspense>;
        $[1] = props;
        $[2] = t1;
      } else {
        t1 = $[2];
      }
      return t1;
    };
    WrappedComponent.displayName = displayName;
    return WrappedComponent;
  }
  const WrappedComponent: FC<PropsType> = function (props) {
    const $ = _c(2);
    let t0;
    if ($[0] !== props) {
      t0 = <Suspense fallback=""><DataLoadingComponent {...props} /></Suspense>;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  };
  WrappedComponent.displayName = displayName;
  return WrappedComponent;
}
export default WithSuspense;